<template>
    <div>
        <div v-if="items && items.length" :class="['listener-album-list', small ? 'is-small' : '']">
            <button
                v-for="item in items"
                :key="item.id"
                :class="['listener-album-list__card', String(currentAlbumId) === String(item.id) ? 'is-active' : '']"
                @click="openAlbum(item)"
            >
                <div class="listener-album-list__image-wrap">
                    <img :src="item.image || '/static/dist/img/album_null.jpg'" :alt="item.name" class="listener-album-list__image">
                    <button class="listener-album-list__play" @click.stop="playNow(item.id)">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M8 5.14v13.72a1 1 0 0 0 1.5.86l10-6.86a1 1 0 0 0 0-1.72l-10-6.86A1 1 0 0 0 8 5.14z"></path>
                        </svg>
                    </button>
                </div>
                <div class="listener-album-list__title">{{ item.name }}</div>
                <div class="listener-album-list__sub">
                    <span>{{ item.artist || $tt('未知艺术家') }}</span>
                    <span v-if="item.year">· {{ item.year }}</span>
                </div>
            </button>
        </div>

        <div v-else class="listener-album-list__empty">
            <h3>{{ $tt('暂无专辑') }}</h3>
            <p>{{ $tt('还没有找到任何专辑，请稍后再试') }}</p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ListenerAlbumList',
    props: {
        items: { type: Array, required: true },
        small: { type: Boolean, default: false }
    },
    computed: {
        ...mapGetters(['track']),
        currentAlbumId() {
            return this.track && this.track.albumId ? this.track.albumId : null
        }
    },
    methods: {
        openAlbum(item) {
            this.$router.push({ name: 'album', params: { id: item.id } })
        },
        async playNow(id) {
            const album = await this.$api.subsonic.getAlbumDetails(id)
            return this.$store.dispatch('playTrackList', {
                tracks: album.tracks
            })
        }
    }
}
</script>

<style scoped>
.listener-album-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.9rem 0.8rem;
}

.listener-album-list.is-small {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.listener-album-list__card {
    border: 0;
    padding: 0.62rem;
    border-radius: 1.6rem;
    background: rgba(255, 255, 255, 0.72);
    text-align: left;
    box-shadow: 0 14px 30px rgba(148, 163, 184, 0.12);
    transition: background 0.22s ease, box-shadow 0.22s ease, transform 0.22s ease;
}

.listener-album-list__card.is-active {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(241, 245, 249, 0.92));
    box-shadow: 0 20px 38px rgba(148, 163, 184, 0.18);
    transform: translateY(-1px);
}

.listener-album-list__card.is-active .listener-album-list__image {
    box-shadow: 0 22px 38px rgba(148, 163, 184, 0.24);
}

.listener-album-list__card.is-active .listener-album-list__play {
    background: #ffffff;
    color: #111827;
    box-shadow: 0 12px 24px rgba(148, 163, 184, 0.2);
}

.listener-album-list__image-wrap {
    position: relative;
}

.listener-album-list__image {
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 1.3rem;
    box-shadow: 0 18px 32px rgba(148, 163, 184, 0.18);
}

.listener-album-list__play {
    position: absolute;
    right: 0.7rem;
    bottom: 0.7rem;
    width: 2.5rem;
    height: 2.5rem;
    border: 0;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(17, 24, 39, 0.92);
    color: #fff;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.2);
}

.listener-album-list__play svg {
    width: 1rem;
    height: 1rem;
}

.listener-album-list__title,
.listener-album-list__sub {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.listener-album-list__title {
    margin-top: 0.72rem;
    font-size: 0.92rem;
    font-weight: 700;
    color: #111827;
}

.listener-album-list__card.is-active .listener-album-list__title {
    color: #0f172a;
}

.listener-album-list__sub {
    margin-top: 0.24rem;
    font-size: 0.8rem;
    color: #64748b;
}

.listener-album-list__card.is-active .listener-album-list__sub {
    color: #94a3b8;
}

.listener-album-list__empty {
    padding: 2rem 1rem;
    text-align: center;
    color: #64748b;
}

.listener-album-list__empty h3 {
    font-size: 1rem;
    font-weight: 700;
    color: #111827;
}

.listener-album-list__empty p {
    margin-top: 0.4rem;
    font-size: 0.82rem;
}
</style>
